import React from 'react';
import { Icon } from '../Icon';
import type { IconProps } from '../.types/IconPropsType';

export function HamburgerMenuIcon(props: IconProps) {
  return (
    <Icon {...props}>
      <svg
        width="16"
        height="14"
        viewBox="0 0 16 14"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M15 6H1C0.4 6 0 6.4 0 7C0 7.6 0.4 8 1 8H15C15.6 8 16 7.6 16 7C16 6.4 15.6 6 15 6Z" />
        <path d="M15 0H1C0.4 0 0 0.4 0 1C0 1.6 0.4 2 1 2H15C15.6 2 16 1.6 16 1C16 0.4 15.6 0 15 0Z" />
        <path d="M15 12H1C0.4 12 0 12.4 0 13C0 13.6 0.4 14 1 14H15C15.6 14 16 13.6 16 13C16 12.4 15.6 12 15 12Z" />
      </svg>
    </Icon>
  );
}
